export const columnHeader = [
  {
    key: 'cpid', name: '#', type: 'text', system: true, filter: true, required: false
  },
 
  {
	  key: 'user', name: 'Mode', type: 'text', system: false, filter: true, required: false
  },
  {
    key: 'uid', name: 'User Id', type: 'text', system: false, filter: true, required: true
  },
  {
    key: 'email', name: 'Email', type: 'text', system: false, filter: true, required: true
  },
  {
    key: 'credit', name: 'Credit', type: 'text', system: false, filter: true, required: false
  },
  {
	  key: 'reference', name: 'Reference', type: 'text', system: false, filter: true, required: false
  },
  {
	  key: 'date', name: 'Date', type: 'text', system: true, filter: true, required: false
  },
  {
	  key: 'actions', name: '', type: 'actions', system: true, filter: false
  }
];

// "cpid": 2911,
//         "": "2022-09-15 09:36:07",
//         "user": "paypal",
//         "uid": 74628,
//         "": 10,
//         "reference": "3Y833433YG820663C",
//         "email": "chimasd123@gmail.com",
//         "token": "ff77bb397f11ddccbc8f2d33b86492eb",
//         "oid": ""